var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormulateInput",
    _vm._b(
      {
        class: _vm.required ? "required" : "",
        attrs: {
          id: _vm.id,
          type: "select-searchable",
          label: _vm.label,
          placeholder: _vm.$t("Digite para pesquisar (min 3 caracteres)"),
          options: _vm.skusOptions,
          validation: _vm.required ? "required" : "",
          "min-search-length": 0,
          instruction: _vm.$t(
            "Busque pelo código EAN (GTIN), código do produto ou nome"
          ),
          "start-search": _vm.startSearch,
          autofocus: _vm.autofocus,
        },
        on: { fetchSearch: _vm.fetchSearchSku, input: _vm.handleInput },
        model: {
          value: _vm.content,
          callback: function ($$v) {
            _vm.content = $$v
          },
          expression: "content",
        },
      },
      "FormulateInput",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }